export enum ColumnDirection {
  left = 'left',
  right = 'right',
}

export const COLLAPSED_COLUMN_WIDTH = 0.25;

export interface IColumn {
  backgroundColor: string;
  collapsable: boolean;
  collapsed?: boolean;
  width: number;
}

export interface IThreeColumnLayout<K = IColumn>
  extends ILayoutBase,
    IThreeColumnLayoutBase<K> {
  typeLogicalId: LayoutType.threecolumns;
}

export interface IDashboardLayout<K = IColumn>
  extends ILayoutBase,
    IThreeColumnLayoutBase<K> {
  typeLogicalId: LayoutType.dashboardlayout;
  topBanner: K;
}

export interface ITabsLayout<K = IColumn>
  extends ILayoutBase,
    IThreeColumnLayoutBase<K> {
  typeLogicalId: LayoutType.tabslayout;
  tabs?: ITabsProps[];
}

export interface ITabsProps {
  name: string;
  title: string;
  iconUrl?: string;
  count?: number;
  widgets?: { children?: React.ReactNode }[];
  hidden?: boolean;
}

export interface IThreeColumnLayoutBase<K = IColumn> {
  leftColumn: K;
  mainColumn: K;
  rightColumn: K;
}

export enum LayoutType {
  default = 'default',
  threecolumns = 'threecolumns',
  tabslayout = 'tabslayout',
  dashboardlayout = 'dashboardlayout',
}

export interface ILayoutBase {
  typeLogicalId: string;
}
